import React from 'react';

function VideoController() {
  return (
    <div
      id="video-bg"
      className="absolute w-full h-full p-4 mt-2"
    >
      <video
        className="w-full h-full object-cover opacity-80 rounded-lg"
        crossOrigin="anonymous"
        autoPlay
        muted
        loop
      >
        <source
          src="/img/linkmedia_thumbnail.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default VideoController;
